<script setup lang="ts">
import { faKey, faPen } from '@fortawesome/pro-regular-svg-icons';

const { mobile, flow = 'login' } = defineProps<{
    mobile: string;
    noOptions?: boolean;
    flow?: 'login' | 'password_reset';
}>();

const emit = defineEmits<{
    submit: [];
    switch: [];
    'change-mobile': [];
    close: [];
}>();

const authStore = useAuthStore();
const { loading } = classToRefs(authStore);
const analyticsStore = useAnalyticsStore();
const token = defineModel<string>('token', { default: '' });
const error = computed(() => authStore.error.Token || '');
const sentMessage = computed(
    () => `کد تأیید برای شماره ${mobile} پیامک و برای پیام‌رسان بله ارسال شد.`
);
const checkToken = () => {
    analyticsStore.trackAll('login_otp_submit', { flow });
    emit('submit');
};
let requestCount = 0;
const loader = async () => {
    const resend = requestCount++ > 0;
    analyticsStore.trackAll('login_otp_send', { flow, resend });
    try {
        await authStore.sendToken(mobile);
        analyticsStore.trackAll('login_otp_send_result', {
            flow,
            resend,
            status: 'success',
        });
    } catch (e) {
        analyticsStore.trackAll('login_otp_send_result', {
            flow,
            resend,
            status: 'failed',
        });
        throw e;
    }
};
</script>

<template>
    <mr-otp
        v-model:token="token"
        :error
        :loader
        :loading
        @submit="checkToken"
        @error="emit('close')"
    >
        <template #extra-header-item>
            <div class="otp-info">
                <mr-typography
                    size="small"
                    weight="500"
                    color="var(--gray-800)"
                >
                    {{ sentMessage }}
                </mr-typography>
                <mr-button
                    variant="transparent"
                    size="small"
                    :right-icon="faPen"
                    @click="
                        analyticsStore.trackAll('login_mobile_edit_click', {
                            flow,
                        });
                        emit('change-mobile');
                    "
                >
                    ویرایش شماره
                </mr-button>
            </div>
        </template>
        <template #tokens-append>
            <mr-button
                v-if="!noOptions"
                variant="transparent"
                size="small"
                :right-icon="faKey"
                class="switch"
                @click="emit('switch')"
            >
                <mr-typography size="small" color="var(--blue-400)">
                    تغییر به ورود با رمز عبور
                </mr-typography>
            </mr-button>
        </template>
        <template #resend="{ resend }">
            <mr-button
                full-width
                @click="
                    analyticsStore.trackAll('login_otp_resend_click', { flow });
                    resend();
                "
            >
                ارسال مجدد کد از طریق پیامک
            </mr-button>
        </template>
    </mr-otp>
</template>

<style scoped lang="scss">
.otp-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.switch {
    align-self: start;
}
</style>
